import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import config from "@Config/index";
import LegacyBlogPost from "@Pages/Blog/BlogPost";

const NewblogPost = loadable(() => import("./NewblogPost"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element =>
  config.IS_CHINA_APP ? (
    <LegacyBlogPost {...props} />
  ) : (
    <ErrorBoundary>
      <NewblogPost {...props} />
    </ErrorBoundary>
  );

export { NewblogPost as PreFetchNewblogPost };
